/* ==========================================================================
   Couleur Paradis : apparition au defilement
   - declenchement a l'entree dans le viewport (IntersectionObserver)
   - anime uniquement opacity et transform (compositeur GPU, aucun reflow)
   - cascade de 100 ms entre les enfants d'une grille
   - ne fait rien si prefers-reduced-motion est actif ou si IO est absent
   - filet de securite : un bloc reste dans le viewport ne peut pas rester masque
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  if (!('IntersectionObserver' in window)) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced && reduced.matches) return;

  /* Grilles : chaque enfant apparait avec un decalage progressif */
  var GROUPS = [
    '.cp-pgrid',
    '.cp-args',
    '.cp-edito',
    '.cp-stores__zones',
    '.cp-faq__in',
    '.cp-ft__cols',
    '.cp-news__in'
  ];

  /* Blocs pleine largeur : apparaissent d'un seul tenant, filets alignes */
  var SOLO = [
    '.cp-hero',
    '.cp-mq',
    '.cp-spot',
    '.cp-stores__top',
    '.cp-stores__soon',
    '.cp-stores__foot',
    '.cp-sechead',
    '.cp-prod',
    '.cp-contact',
    '.cp-pagehead',
    '.cp-prose',
    '.cp-404',
    '.cp-cart-page',
    '.cp-cart-foot',
    '.cp-searchbar',
    '.cp-empty'
  ];

  var MAX_STEPS = 8;
  var observer = null;
  var pending = [];
  var ticking = false;

  function show(el) {
    el.classList.add('cp-in');
    var at = pending.indexOf(el);
    if (at !== -1) pending.splice(at, 1);
    if (observer) observer.unobserve(el);
  }

  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) show(entries[i].target);
    }
  }

  /* Filet de securite : si l'IntersectionObserver ne rend pas la main
     (onglet en arriere-plan, saut de defilement, navigation instantanee),
     on verifie nous-memes les blocs encore masques. Le controle s'arrete
     de lui-meme des qu'il n'y a plus rien en attente. */
  function sweep() {
    ticking = false;
    if (!pending.length) {
      window.removeEventListener('scroll', queueSweep);
      window.removeEventListener('resize', queueSweep);
      return;
    }
    var limit = window.innerHeight || root.clientHeight;
    for (var i = pending.length - 1; i >= 0; i--) {
      var box = pending[i].getBoundingClientRect();
      if (box.top < limit * 0.95 && box.bottom > 0) show(pending[i]);
    }
  }

  function queueSweep() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(sweep);
  }

  function prepare(el, step) {
    if (!el || el.nodeType !== 1) return;
    if (el.hasAttribute('data-cp-reveal')) return;
    el.setAttribute('data-cp-reveal', '');
    if (step > 0) {
      el.style.setProperty('--cp-reveal-i', String(Math.min(step, MAX_STEPS)));
    }
    pending.push(el);
    observer.observe(el);
  }

  function scan(scope) {
    var context = scope && scope.querySelectorAll ? scope : doc;
    var i, j, k;

    for (i = 0; i < GROUPS.length; i++) {
      var grids = context.querySelectorAll(GROUPS[i]);
      for (j = 0; j < grids.length; j++) {
        var kids = grids[j].children;
        for (k = 0; k < kids.length; k++) prepare(kids[k], k);
      }
    }

    for (i = 0; i < SOLO.length; i++) {
      var blocks = context.querySelectorAll(SOLO[i]);
      for (j = 0; j < blocks.length; j++) prepare(blocks[j], 0);
    }

    window.addEventListener('scroll', queueSweep, { passive: true });
    window.addEventListener('resize', queueSweep, { passive: true });
    queueSweep();
  }

  function revealAll() {
    while (pending.length) show(pending[0]);
  }

  function init() {
    root.classList.add('cp-reveal-on');

    observer = new IntersectionObserver(onIntersect, {
      rootMargin: '0px 0px -5% 0px',
      threshold: 0
    });

    scan(doc);

    /* Editeur de theme : une section rechargee doit etre reprise en compte */
    doc.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });

    /* Retour sur l'onglet : on rattrape ce qui aurait ete manque */
    doc.addEventListener('visibilitychange', function () {
      if (!doc.hidden) queueSweep();
    });

    /* Si l'utilisateur active la reduction de mouvement en cours de route */
    if (reduced && reduced.addEventListener) {
      reduced.addEventListener('change', function (event) {
        if (event.matches) revealAll();
      });
    }
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
